/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { FIELD_FLOATING_PANEL_STYLE, FieldFloatingPanel } from "../FieldFloatingPanel";
import { Button, FC_ANCHOR, FC_DIRECTION, Icon, ICON_SIZE } from "../../core";
import { COLOR } from "../../../enums/COLOR";

import "./FieldResourceSelectorPanel.scss";

export interface IFieldResourceSelectorPanelProps {
	className?: string;
	children?: React.ReactNode;
	anchorEl?: React.MutableRefObject<HTMLElement>;
	isOpened?: boolean;
	panelAnchor?: FC_ANCHOR;
	panelDirection?: FC_DIRECTION;
	panelOffset?: number;
	onClose?: () => void;
	onCreate?: () => void;
	title?: string;
}

export const FieldResourceSelectorPanel: React.FC<IFieldResourceSelectorPanelProps> = ({
	className,
	children,
	anchorEl,
	panelAnchor,
	panelDirection,
	isOpened,
	panelOffset,
	onClose,
	onCreate,
	title
}) => {
	const baseClass = BEM("edt-field-resource-selector-panel");

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldFloatingPanel
			for={anchorEl}
			isOpened={isOpened}
			anchor={panelAnchor || FC_ANCHOR.RIGHT_BOTTOM}
			direction={panelDirection || FC_DIRECTION.HR}
			style={FIELD_FLOATING_PANEL_STYLE.STICKY}
			offset={panelOffset || 1}
			className="edt-field--type-resource__panel"
			onClose={onClose}
			title={title}
			titleSecondary={
				onCreate ? (
					<Button
						color={COLOR.PRIMARY}
						onClick={onCreate}
						className={baseClass.element("create-btn").toClassName()}
						startIcon={
							<Icon
								className={baseClass.element("create-btn-icon").toClassName()}
								name="mdi/plus"
							/>
						}
					>
						CREATE
					</Button>
				) : null
			}
		>
			{children}
		</FieldFloatingPanel>
	);
};
